import React from "react";
import Util from "../libs/util";
import { getMDRTypes } from "../libs/functions";

export default function SSR(Page) {
	class SSR extends React.Component {
		static getInitialData(ctx) {
			return Page.getInitialData ? Page.getInitialData(ctx) : Promise.resolve(null);
		}

		constructor(props) {
			super(props);
			this.state = {
				data: props.initialData,
				isLoading: false,
			};

			this.ignoreLastFetch = false;
		}

		componentDidMount() {
			if (!this.state.data) {
				this.fetchData();
			}

			getMDRTypes().then((MDRTypes) => {
				this.setState({ MDRTypes: MDRTypes });
			});
		}

		componentWillUnmount() {
			this.ignoreLastFetch = true;
		}

		executeFetchData = (loader, fn, payload) => {
			return new Promise((resolve, reject) => {
				loader(true);
				fn(payload).then(
					(data) => {
						loader(false);
						resolve(data);
					},
					(error) => {
						loader(false);
						if (
							error.response &&
							(error.response.status === 401 || error.response.status === 400)
						) {
							Util.expireSession().then((result) => {
								window.location = "/login";
							});
						} else reject(error);
					}
				);
			});
		};

		fetchData = () => {
			if (!this.ignoreLastFetch) {
				this.setState({ isLoading: true });
				this.constructor.getInitialData({ match: this.props.match }).then(
					(data) => {
						this.setState({
							data,
							isLoading: false,
						});
					},
					(error) => {
						console.log(error);
						if (error.status === 401) {
							Util.expireSession().then((result) => {
								window.location = "/login";
							});
						} else {
							this.setState((state) => ({
								data: { error },
								isLoading: false,
							}));
						}
					}
				);
			}
		};

		render() {
			const { initialData, userData, ...rest } = this.props;
			return (
				<Page
					{...rest}
					fetchInitial={this.fetchData}
					fetchData={this.executeFetchData}
					isLoading={this.state.isLoading}
					userData={userData}
					MDRTypes={this.state.MDRTypes}
					{...this.state.data}
				/>
			);
		}
	}

	SSR.displayName = `SSR(${getDisplayName(Page)})`;

	return SSR;
}

function getDisplayName(WrappedComponent) {
	return WrappedComponent.displayName || WrappedComponent.name || "Component";
}
